export const AFTER_RUN_ALERT_TYPE = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export const INPUT_DATA_LOCATION_TYPES = {
  MANUALLY_SET: 'manually-set',
  EXISTING_SESSION: 'existing-session',
  RUN_VIA_API: 'run-via-api',
};
